import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { getTokenPayload, getUserToken } from "../../hooks/useLogin";
import { openAlert } from "../../components/Modal/MsgBox";

import routes from "../../routes";

import styled from "styled-components";

const StyledNav = styled.nav`
  &::after {
    width: calc(100% / ${(props) => props.$tabsTotal});
    transform: translateX(calc(100% * ${(props) => props.$selectedTab}));
  }
`;

function Tab(props) {
  const { id, className, onClick, tabIndex, ariaSelected, title } = props;
  return (
    <button
      type="button"
      id={`tab-${id}`}
      className={className}
      onClick={onClick}
      role="tab"
      tabIndex={tabIndex}
      aria-controls={`tabpanel-${id}`}
      aria-selected={ariaSelected}
    >
      <span>{title}</span>
    </button>
  );
}

function TabNav(props) {
  const { animate, tabsNumber, selectedIndex, children } = props;

  return (
    <StyledNav
      className="gs-nav-tabs"
      role="tablist"
      aria-label="Tabbed content"
      data-animate={animate}
      $selectedTab={selectedIndex}
      $tabsTotal={tabsNumber}
    >
      {children}
    </StyledNav>
  );
}

function RegulationTabs(props) {
  const { tabsData, activatedTab, className, tabonly, animate } = props;
  const [selectedTab, setSelectedTab] = useState(
    !activatedTab ? 0 : activatedTab,
  );

  const selectTabHandler = (index) => {
    setSelectedTab(index);
  };

  return (
    <div
      className={className ? `gs-nav-tab-con ${className}` : "gs-nav-tab-con"}
    >
      <TabNav
        animate={animate}
        tabsNumber={tabsData?.length}
        selectedIndex={selectedTab}
      >
        {tabsData?.map((tab, i) => (
          <Tab
            key={i}
            id={tab?.uid}
            className={i === selectedTab ? "gs-tab-item active" : "gs-tab-item"}
            onClick={() => selectTabHandler(i)}
            tabIndex={i === selectedTab ? null : "-1"}
            ariaSelected={i === selectedTab ? "true" : "false"}
            title={`${tab?.designatedDate} ${tab?.designatedForm}`}
          />
        ))}
      </TabNav>
      {!tabonly && (
        <div className="gs-tab-content">
          <div
            id={`tabpanel-${tabsData[selectedTab]?.uid}`}
            className="gs-tab-pane"
            role="tabpanel"
            aria-labelledby={`tab-${tabsData[selectedTab]?.uid}`}
            dangerouslySetInnerHTML={{ __html: tabsData[selectedTab]?.content }}
          />
        </div>
      )}
    </div>
  );
}

function Tabs(props) {
  const { tabsData, activatedTab, className, tabonly, animate } = props;
  const [selectedTab, setSelectedTab] = useState(
    !activatedTab ? 0 : activatedTab,
  );

  const selectTabHandler = (index) => {
    setSelectedTab(index);
  };

  return (
    <div
      className={className ? `gs-nav-tab-con ${className}` : "gs-nav-tab-con"}
    >
      <TabNav
        animate={animate}
        tabsNumber={tabsData.length}
        selectedIndex={selectedTab}
      >
        {tabsData.map((tab, i) => (
          <Tab
            key={i}
            id={tab.id}
            className={i === selectedTab ? "gs-tab-item active" : "gs-tab-item"}
            onClick={() => selectTabHandler(i)}
            tabIndex={i === selectedTab ? null : "-1"}
            ariaSelected={i === selectedTab ? "true" : "false"}
            title={tab.title}
          />
        ))}
      </TabNav>
      {!tabonly && (
        <div className="gs-tab-content">
          <div
            id={`tabpanel-${tabsData[selectedTab].id}`}
            className="gs-tab-pane"
            role="tabpanel"
            aria-labelledby={`tab-${tabsData[selectedTab].id}`}
          >
            {tabsData[selectedTab].content}
          </div>
        </div>
      )}
    </div>
  );
}

function TabsLink(props) {
  const { tabsData, activatedTab, className, animate, onTabChange } = props;

  const { pathname } = useLocation();
  const pathParts = pathname.split("/");
  const modifiedPath = pathParts.slice(0, 3).join("/");
  const pathIndex = routes.findIndex((item) =>
    item.path.includes(modifiedPath),
  );

  let tabIndex = 0;

  if (routes[pathIndex].currentTabIndex) {
    tabIndex = routes[pathIndex].currentTabIndex;
  }

  const handleTabClick = (e, tab) => {
    if (!tab.requireLogin) {
      return;
    }

    const isLogin = getUserToken() !== "" && getTokenPayload().id !== 0;

    if (!isLogin) {
      e.preventDefault();

      openAlert("로그인이 필요한 서비스입니다.", () => {
        window.location.href = "/account/login";
      });
    }
  };

  useEffect(() => {
    onTabChange(tabIndex);
    sessionStorage.removeItem("language");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabIndex]);

  return (
    <div
      className={className ? `gs-nav-tab-con ${className}` : "gs-nav-tab-con"}
    >
      <TabNav
        animate={animate}
        tabsNumber={tabsData.length}
        selectedIndex={activatedTab}
      >
        {tabsData.map((tab, i) => (
          <Link
            key={i}
            //id={tab.id}
            to={tab.href}
            target={tab.target}
            onClick={(e) => handleTabClick(e, tab)}
            className={
              i === activatedTab ? "gs-tab-item active" : "gs-tab-item"
            }
            title={tab.target && "새창열림"}
          >
            <span>{tab.title}</span>
          </Link>
        ))}
      </TabNav>
    </div>
  );
}

export { Tab, TabNav, RegulationTabs, Tabs, TabsLink };
